import { Box } from '@mui/material';
import { get } from 'lodash';
import React, { FC } from 'react';
import MarkdownRenderer from 'src/components/ui-component/markdown-renderer/MarkdownRenderer';
import { useFoerderProgramm } from 'src/context/FoerderProgrammContext';
import { isTrue } from 'src/utils/helper';

// import Schemas
import FoerderRichtlinieSchema from 'src/lib/paths/foerderrichtlinie_FULL_Paths.json';
const FR_P = FoerderRichtlinieSchema.attributes;

const AntragStellungGespertHinweis: FC<{}> = () => {
	const { foerderRichtlinieDetails } = useFoerderProgramm();

	const isAktiv = get(foerderRichtlinieDetails, FR_P.Allgemein_Optionaler_Hinweis_Aktiv.path, false);
	const inhalt = get(foerderRichtlinieDetails, FR_P.Allgemein_Optionaler_Hinweis_Inhalt.path, '');

	if (isTrue(isAktiv) && isTrue(inhalt)) {
		return (
			<Box sx={{ p: '1rem 2rem', backgroundColor: '#fff', border: '4px solid #f00', mb: '1rem' }}>
				<MarkdownRenderer markdown={inhalt} />
			</Box>
		);
	}

	return <></>;
};

export default AntragStellungGespertHinweis;
